var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{ref:"paragraph",class:_vm.classString,style:(_vm.cssString),domProps:{"innerHTML":_vm._s(_vm.$t(_vm.html))},on:{"input":_vm.updateComponent}})
}
var staticRenderFns = []

export { render, staticRenderFns }